import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { NotifierService } from "../Components/Services/notifier.service";
import { Router } from "@angular/router";
import { UserConfigService } from "src/app/Services/AuthService/user-config.service";
import { AuthService } from "src/app/Services/AuthService/auth.service";
import { catchError, filter, finalize, switchMap, take } from "rxjs/operators";
import { MessageService } from "primeng/api";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private notifierService: NotifierService,
    private router: Router,
    private userConfigService: UserConfigService,
    private authService: AuthService,
    private messageService: MessageService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap(
        () => {},
        (err) => {
          if (err.status === 401) {
            this.authService.clearCookie();
            this.userConfigService.setUserConfig({
              name: "",
              profileImg: "",
              isSuperAdmin: null,
              accountTypeCode: "",
              companyName: "",
              isLoggedIn: false,
              token: "",
              currencyCode: "",
              emailAddress: "",
              accountId: null,
              currencyId: null,
              userId: null,
              roleCode: "",
              roleId: null,
              userPermissionsLists: [],
              displayBoardingVideo: false,
            });
            this.router.navigate(["auth", "sign-in"]);
            
            // if(!this.authService.voluntaryLogout)
            
            if(!this.authService.voluntaryLogout) {
              this.notifierService
                .onError(
                  "error_outline",
                  "Logged Out",
                  "Sorry you need to login.."
                )
                .then((c) => {
                  // window.location.reload();
                });
                this.authService.voluntaryLogout = false;    
            }
          }
           else {
            this.messageService.add({
              key: "bc",
              severity: "warn",
              detail: "Server error detected!",
              sticky: true,
            });
            // this.notifierService
            //   .onError(
            //     "error_outline",
            //     "Something went wrong!",
            //     "Server error detected!!"
            //   )
            //   .then((c) => {
            //     // window.location.reload();
            //   });
          }
        }
      )
    );
  }
}
